import { render } from "./marketplace_error.html?vue&type=template&id=6d7be576&scoped=true&external"
import script from "./marketplace_error.js?vue&type=script&lang=js&external"
export * from "./marketplace_error.js?vue&type=script&lang=js&external"

import "./MicrosoftMarketplaceError.vue?vue&type=style&index=0&id=6d7be576&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7be576"]])

export default __exports__